import { addZ } from './utils';

// Keep clock fields separate from Dates while editing: no timezone or DST conversion.
export function parseTimeInput(value, seconds = false) {
  const count = seconds ? 3 : 2;
  let text = typeof value === 'string' ? value.trim() : '';
  if (new RegExp(`^\\d{${count * 2}}$`).test(text)) text = text.match(/.{2}/g).join(':');
  const parts = text.split(':');
  if (
    parts.length !== count ||
    parts.some((part, index) => !/^\d{1,2}$/.test(part) || Number(part) > (index === 0 ? 23 : 59))
  )
    return null;
  return [...parts.map(Number), ...(seconds ? [] : [0])];
}

export function formatTimeParts(parts, seconds = false) {
  return parts
    .slice(0, seconds ? 3 : 2)
    .map(addZ)
    .join(':');
}

// Add separators during forward entry; leave manually shortened clock fields alone.
export function addTimeInputSeparators(text, seconds = false) {
  const groups = text.replace(/(\d{2}:):$/, '$1').split(':');
  if (
    groups.some((group) => !/^\d*$/.test(group)) ||
    groups.slice(0, -1).some((group) => group.length !== 2)
  )
    return text;
  const digits = groups.join('');
  const limit = seconds ? 6 : 4;
  if (!digits || digits.length > limit) return text;
  const formatted = digits.match(/.{1,2}/g).join(':');
  return digits.length < limit && digits.length % 2 === 0 ? `${formatted}:` : formatted;
}

export function readTimeParts(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? null
      : [value.getHours(), value.getMinutes(), value.getSeconds()];
  }
  return parseTimeInput(value, true) || parseTimeInput(value);
}

export function timePartsToDate(parts) {
  // Preserve the Date callback contract used by timing, scheduling and IO overrides.
  return new Date(1995, 6, 21, parts[0], parts[1], parts[2], 0);
}

export function timePartsToSeconds(parts) {
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
}

export function secondsToTimeParts(seconds) {
  return [Math.floor(seconds / 3600), Math.floor((seconds % 3600) / 60), seconds % 60];
}
